import { connect } from 'react-redux';
import App from 'common/backbone-app';
import { AccountLanguageSelect as Component } from './AccountLanguageSelect';

const mapStateToProps = () => ({
  isMasquerading: App.isMasquerading(),
});

export const AccountLanguageSelect = connect(mapStateToProps)(Component);
